import { render, staticRenderFns } from "./PanoramicaEtichettePartner.vue?vue&type=template&id=2a399106&scoped=true&"
import script from "./PanoramicaEtichettePartner.vue?vue&type=script&lang=js&"
export * from "./PanoramicaEtichettePartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a399106",
  null
  
)

export default component.exports